<template>
    <div class="block-child">
        <img
            srcset="../assets/child.jpg, ../assets/child@2x.jpg 2x"
            src="../assets/child.jpg"
            class="block-child__img"
        >
        <div class="image-caption image-caption--overlap-left">Сквер в проекте Green&nbsp;Park</div>

        <BlockParallax
            class="block-child__content"
            fixed
            speed="14"
            direction="top"
            transform="translateY"
        >
            <span class="block-child__title">Ребенок и мир</span>
            <p class="block-child__text">
                Курсы и занятия с репетитором проходят не&nbsp;всегда рядом с домом. Поэтому подросток все чаще ездит в другие районы. У него появляются новые друзья, но уже вне школы и&nbsp;двора. Например, в соцсетях или на курсах.
                <br><br>
                Многие дети увлекаются робототехникой или снимают видео для блога. В этом им не нужна помощь родителей. И их знаниям о монтаже видео или планах на работу в Силиконовой долине можно только позавидовать.
            </p>
        </BlockParallax>
        <BlockParallax class="block-child__icon-box block-child__cup" speed="13" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/1517-cup.png"
                class="block-child__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-child__icon-box block-child__heart" speed="14" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/1517-heart-blue.png"
                class="block-child__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-child__icon-box block-child__clock" speed="16" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/1517-clock.png"
                class="block-progress__icon"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-child {
        margin-top 3rem
        margin-left -1rem
        margin-right -1rem
        font-size 0
        position relative

        +layout-sm-and-up() {
            margin-left 0
            margin-right 0
        }
        +layout-md-and-up() {
            margin-top 5rem
        }

        &__img {
            position relative
            z-index 4
            object-fit contain
            +layout-sm-and-up() {
                max-width 100%
            }

            +layout-xs() {
                width 100%
                height 355px
                object-fit cover
            }
        }

        &__content {
            position relative
            max-width 46rem
            background-color #328ec6
            padding 2rem 2rem 3rem 2rem
            margin-left 4rem
            margin-top -10rem
            z-index 5
            +layout-sm-and-up() {
                margin-left auto
                margin-right 8rem
            }
            +layout-md-and-up() {
                padding 4rem 6rem
                padding-bottom 7rem
                margin -8rem 8rem 0 auto
                position relative
            }
        }

        &__title {
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-white
            +layout-md-and-up() {
                font-size 3rem
            }
        }

        &__text {
            color #fff
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
        }

        &__icon-box {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-vane {
            z-index 100
            position absolute
            right -20px
            top -59px
            width 12rem
            height 12rem
            +layout-md-and-up() {
                right 0
                top -16.6rem
                width 20rem
                height 20rem
            }
        }

        &__cup {
            top -16rem
            z-index -1
            width 3.9rem
            left -1rem
            transform rotate(0deg)
            +layout-md-and-up() {
                top 22.2rem
                left auto
                right -12rem
                width 9rem
                height 12rem
                z-index 0
                img {
                    transform rotate(-40deg)
                }
            }
        }

        &__heart {
            top -23.5rem
            right .8rem
            width 2.5rem
            transform rotate(45deg)
            z-index 4
            +layout-md-and-up() {
                top auto
                right auto
                left -4rem
                bottom 22rem
                width auto
                img {
                    transform rotate(150deg)
                }
            }
        }

        &__clock {
            top -8rem
            right 1.8rem
            width 4.8rem
            transform rotate(15deg)
            z-index -1
            +layout-md-and-up() {
                top auto
                right auto
                left 9rem
                bottom 11rem
                width 12.6rem
                img {
                    transform rotate(-90deg)
                }
            }
        }
    }
</style>
